import { combineEpics, Epic, ofType } from "redux-observable";
import { from, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { AuthActions } from "../auth/actions";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { VaultActions } from "./actions";
import { VaultsDTO } from "./models/dto";
import { VaultService } from "./service";

const getVaultsEpic: Epic<VaultActions.Actions> = (action$) =>
  action$.pipe(
    ofType(VaultActions.ActionTypes.getAllVaults),
    switchMap<
      VaultActions.Actions,
      Observable<
        FetchableError | FetchableSuccess<VaultsDTO.Responses.GetAllVaults.T>
      >
    >(() => VaultService.getVaults()),
    map((x) => VaultActions.setAllVaults(x))
  );

const setAllVaultsPaginationEpic: Epic<VaultActions.Actions> = (action$) =>
  action$.pipe(
    ofType(VaultActions.ActionTypes.setAllVaultsPagination),
    switchMap<
      VaultActions.SetAllVaultsPagination,
      Observable<
        FetchableError | FetchableSuccess<VaultsDTO.Responses.GetAllVaults.T>
      >
    >((action) => {
      return VaultService.getVaults(action.payload);
    }),
    map((x) => VaultActions.setAllVaults(x))
  );

const getVaultEntriesEpic: Epic<VaultActions.Actions> = (action$) =>
  action$.pipe(
    ofType(VaultActions.ActionTypes.getAllVaultEntries),
    switchMap<
      VaultActions.GetAllVaultEntries,
      Observable<{
        vaultId: VaultsDTO.Responses.GetSingleVault.T["id"];
        entries:
          | FetchableError
          | FetchableSuccess<VaultsDTO.Responses.GetAllEntries.T>;
      }>
    >(({ payload }) =>
      VaultService.getVaultEntries(payload).pipe(
        map((entries) => ({
          entries,
          vaultId: payload,
        }))
      )
    ),
    map((x) => VaultActions.setAllVaultEntries(x))
  );

const setAllVaultEntriesPaginationEpic: Epic<VaultActions.Actions> = (
  action$
) =>
  action$.pipe(
    ofType(VaultActions.ActionTypes.setAllVaultsPagination),
    switchMap<
      VaultActions.SetAllVaultsPagination,
      Observable<
        FetchableError | FetchableSuccess<VaultsDTO.Responses.GetAllVaults.T>
      >
    >((action) => {
      return VaultService.getVaults(action.payload);
    }),
    map((x) => VaultActions.setAllVaults(x))
  );

const dependencies: Epic<
  AuthActions.Actions | VaultActions.Actions,
  VaultActions.Actions
> = (action$) =>
  action$.pipe(
    ofType(AuthActions.ActionTypes.authDone),
    switchMap(() => from([VaultActions.resetAllVaults()]))
  );

export const vaultsEpic = combineEpics(
  getVaultsEpic,
  setAllVaultsPaginationEpic,
  getVaultEntriesEpic,
  setAllVaultEntriesPaginationEpic,
  dependencies
);
